const firebaseConfig = {
    apiKey: "AIzaSyCx6iELoplfIKmQxjUOmqRjXPC9XNYxpDs",
    authDomain: "we-care-healthcare.firebaseapp.com",
    projectId: "we-care-healthcare",
    storageBucket: "we-care-healthcare.appspot.com",
    messagingSenderId: "474695875870",
    appId: "1:474695875870:web:8cfbd8189484d0b16c5d0f"
  };
  export default firebaseConfig;